import React, { useEffect, useState } from 'react';
import styles from './intro.module.scss';
import classNames from 'classnames/bind';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';

const cx = classNames.bind(styles);

export const Intro = () => {
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const [audioStep, setAudioStep] = useState(0);

  const setOpacity = (step: number) => {
    let value = 1;
    if (audioStep !== step) value = 0.5;

    return {
      opacity: value,
    };
  };

  useEffect(() => {
    setTimeout(() => setAudioStep(1), 1600);
    setTimeout(() => setAudioStep(2), 3100);
    setTimeout(() => toNextStep(), 6000);
  }, []);

  return (
    <div className={cx('introWrap')}>
      <div className={cx('message')}>
        <Text fontStyle={FontStyle.H1_B} color={Colors.C_WHITE} styles={setOpacity(0)}>
          안녕하세요.
        </Text>
        <Text fontStyle={FontStyle.H1_B} color={Colors.C_WHITE} styles={setOpacity(1)}>
          지금부터 저와 함께
        </Text>
        <Text fontStyle={FontStyle.H1_B} color={Colors.C_WHITE} styles={setOpacity(2)}>
          면접 연습을 진행해 볼게요.
        </Text>
      </div>
    </div>
  );
};
